// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
frappe._get_default_contexts = function () {
	let contexts = [];
	let doctype = null;

	if (window.cur_frm && cur_frm.doctype) {
		doctype = cur_frm.doctype;
	} else if (frappe.get_route) {
		const route = frappe.get_route();
		if (route && route.length > 1) {
			const route_type = route[0];
			if (["Form", "List", "Report", "Tree"].includes(route_type)) {
				doctype = route[1];
			}
		}
	}

	if (doctype) {
		contexts.push(doctype);
	}

	return contexts;
};

frappe._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	let contexts = context ? [context] : frappe._get_default_contexts();
	for (const ctx of contexts) {
		translated_text = frappe._messages[`${key}:${ctx}`];
		if (translated_text) break;
	}

	if (!translated_text) {
		translated_text = frappe._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = frappe._;

frappe.get_languages = function () {
	if (!frappe.languages) {
		frappe.languages = [];
		$.each(frappe.boot.lang_dict, function (lang, value) {
			frappe.languages.push({ label: lang, value: value });
		});
		frappe.languages = frappe.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return frappe.languages;
};
